import type { Permission } from '@/config/permissions';
import { useApprovalStore } from '@/stores/approval';
import { useUserStore } from '@/stores/user';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export function hasPermission(route: RouteLocationNormalized): boolean {
  const userStore = useUserStore();
  const approvalStore = useApprovalStore();
  const meta = route.meta ?? {};
  const requiredPerms = (meta.permissions as Permission[] | undefined) ?? [];
  const requiresApprover = Boolean((meta as { requiresApprover?: boolean }).requiresApprover);
  const requiresAllConditions = Boolean(
    (meta as { requiresAllConditions?: boolean }).requiresAllConditions,
  );

  const conditions: boolean[] = [];

  if (requiredPerms.length > 0) {
    const permOk = requiredPerms.some((p) => userStore.permissions.includes(p));
    conditions.push(permOk);
  }
  if (requiresApprover) {
    conditions.push(approvalStore.isCurrentUserApprover());
  }

  if (conditions.length === 0) return true; // 未声明任一条件默认放行

  // requiresAllConditions: true 时需要所有条件都满足（AND），否则任一满足即可（OR）
  return requiresAllConditions ? conditions.every(Boolean) : conditions.some(Boolean);
}

export function permissionGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  if (hasPermission(to)) return next();
  return next({ name: 'Unauthorized' });
}
